const GROUPS = [
  {
    tag: "HOAs",
    title: "Homeowner associations",
    body:
      "For self-managed and professionally managed HOAs with 100+ parcels. We publish the exact records FS 720.303(5) requires, saving your board from managing technical database tasks.",
    bullets: [
      "Governing documents and amendments",
      "Board and committee meeting notices",
      "Annual budgets and financial reports",
      "Reserve schedules and vendor contracts",
    ],
    image:
      "https://readdy.ai/api/search-image?query=aerial%20drone%20photograph%20of%20south%20florida%20suburban%20master%20planned%20homeowner%20association%20neighborhood%20with%20red%20tile%20roofs%20lakes%20and%20palm%20trees%20under%20soft%20warm%20afternoon%20light%2C%20clean%20editorial%20architectural%20photography%2C%20muted%20warm%20tones%2C%20lush%20tropical%20landscaping%20and%20geometric%20street%20layout&width=1200&height=1400&seq=aud-hoa-01&orientation=portrait",
  },
  {
    tag: "Condominiums",
    title: "Condo associations",
    body:
      "Post-Surfside, every Florida condo has new reporting obligations. We turn milestone inspections, SIRS and structural reserves into a clean, owner-friendly section of your site.",
    bullets: [
      "Milestone inspection reports",
      "Structural Integrity Reserve Study",
      "Insurance certificates and claims",
      "Turnover audits and construction",
    ],
    image:
      "https://readdy.ai/api/search-image?query=elegant%20oceanfront%20high%20rise%20condominium%20towers%20in%20south%20florida%20with%20turquoise%20ocean%20swimming%20pool%20cabanas%20and%20palm%20trees%20under%20warm%20late%20afternoon%20golden%20light%2C%20refined%20editorial%20real%20estate%20photography%2C%20muted%20warm%20amber%20and%20soft%20teal%20tones%2C%20architectural%20elegance&width=1200&height=1400&seq=aud-condo-02&orientation=portrait",
  },
  {
    tag: "55+ Communities",
    title: "Age-restricted residences",
    body:
      "Keep the HOPA 80/20 exemption defensible. We handle the policy statement, occupancy surveys, age-verification intake and HUD-ready record trail on your website.",
    bullets: [
      "HOPA policy statement page",
      "Biennial occupancy survey portal",
      "Age-verification workflow",
      "Large-type accessibility mode",
    ],
    image:
      "https://readdy.ai/api/search-image?query=serene%20south%20florida%2055%20plus%20active%20adult%20community%20clubhouse%20with%20swimming%20pool%20pickleball%20courts%20and%20palm%20trees%20under%20soft%20warm%20morning%20light%2C%20aspirational%20lifestyle%20editorial%20photography%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20lush%20landscaping%20and%20mediterranean%20architecture&width=1200&height=1400&seq=aud-55plus-03&orientation=portrait",
  },
];

export default function Audience() {
  return (
    <section id="audience" className="py-24 md:py-32 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-primary-700 font-semibold">
            <i className="ri-community-line" />
            Who we serve
          </span>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl font-semibold text-foreground-950 leading-[1.05]">
            Built for the three community structures Florida regulates hardest.
          </h2>
        </div>

        <div className="grid lg:grid-cols-3 gap-6">
          {GROUPS.map((g) => (
            <article
              key={g.tag}
              className="group relative rounded-lg overflow-hidden border border-background-200 bg-background-50 flex flex-col"
            >
              <div className="relative h-72 overflow-hidden">
                <img
                  src={g.image}
                  alt={g.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent" />
                <span className="absolute top-4 left-4 bg-background-50/95 text-foreground-950 text-xs font-semibold px-3 py-1.5 rounded-full">
                  {g.tag}
                </span>
                <h3 className="absolute bottom-4 left-4 right-4 font-heading text-2xl font-semibold text-background-50">
                  {g.title}
                </h3>
              </div>
              <div className="p-7 flex-1 flex flex-col">
                <p className="text-foreground-700 leading-relaxed text-sm">{g.body}</p>
                <ul className="mt-6 space-y-2.5">
                  {g.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-2 text-sm text-foreground-800">
                      <i className="ri-checkbox-circle-fill text-primary-600 mt-0.5" />
                      {b}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}